import styled from 'styled-components';
import { COLORS } from 'modules/core/theme/colors';

export const Badge = styled.span<{ color: string; isCardView: boolean; textColor: string; borderColor: string }>`
  padding: ${({ isCardView }) => (isCardView ? '4px 7px' : '2px 5px')};
  color: ${({ textColor }) => textColor || COLORS.WHITE} !important;
  font-size: ${({ isCardView }) => (isCardView ? '12px' : '8px')};
  background-color: ${({ color }) => color} !important;
  border: 1px solid ${({ borderColor, color }) => borderColor || color} !important;
  border-radius: 4px;
  font-weight: bold;
`;
